export default {
    id: 'comments__placeholder',
    template: 'Комментарии недоступны для данной задачи!',
};
